/**
 * Created with IntelliJ IDEA.
 * User: nzamuruev
 * Date: 25.09.13
 * Time: 15:47
 * To change this template use File | Settings | File Templates.
 */

import { ExternalLoggingConstants } from "../ExternalLoggingConstants";
import { AbstractLogObject } from "../logObjects/AbstractLogObject";
import { BasicLogObjectFactory } from "./BasicLogObjectFactory";

export class TrackingVerificationErrorLOFactory extends BasicLogObjectFactory {
    public static TRACKING_EVENTS_MISSING_ERROR: number = 8001;
    private static TRACKING_VERIFICATION_ERROR: number = 8;

    private static PARAM_MISSING_EVENTS: string = "listOfFaultyEvents";
    private static PARAM_TRACKING_CASE: string = "trackingCase";

    private _trackingCase: string;
    private _missingEvents: string;

    constructor(subErrorId: number, trackingCase: string, missingEvents: string) {
        super();

        this._subErrorId = subErrorId;
        this._trackingCase = trackingCase;
        this._missingEvents = missingEvents;
    }

    public create(): AbstractLogObject {
        // Build the commonData
        let lo: AbstractLogObject = super.create();

        // Update with customData
        lo.logData.set(ExternalLoggingConstants.PARAM_LOG_EVENT_ID, TrackingVerificationErrorLOFactory.TRACKING_VERIFICATION_ERROR.toString());

        lo.logData.set(TrackingVerificationErrorLOFactory.PARAM_TRACKING_CASE, this._trackingCase);
        lo.logData.set(TrackingVerificationErrorLOFactory.PARAM_MISSING_EVENTS, this._missingEvents);

        return lo;
    }
}
